/* eslint-disable max-len */
import { number, string } from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const ContractIconSvg = styled.svg`
  width: ${prop('size', 36)}px;
  height: ${prop('size', 36)}px;
  :hover {
    .b {
      fill: ${prop('hoverColor', colorsOptions.greys['grey-100'])};
    }
  }
  .a {
    fill: none;
  }
  .b {
    fill: ${prop('color', colorsOptions.greys['grey-100'])};
  }
`

function ContractIcon ({ color, hoverColor, size, ...props }) {
  return (
    <ContractIconSvg
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
      viewBox="0 0 32 32.106"
    >
      <defs>
        <clipPath id="clip-path">
          <rect className="a" width="32" height="32.106" />
        </clipPath>
      </defs>
      <g id="Gruppe_9">
        <path
          className="b"
          d="M22.538,6.39a.41.41,0,0,0-.016-.045.505.505,0,0,0-.093-.138l0,0L16.365.142h0a.459.459,0,0,0-.138-.093L16.178.032a.452.452,0,0,0-.126-.025A.3.3,0,0,0,16.021,0H.486A.486.486,0,0,0,0,.487V31.619a.486.486,0,0,0,.486.486h21.6a.486.486,0,0,0,.486-.486V6.548c0-.01-.005-.018-.006-.029a.509.509,0,0,0-.026-.129m-1.629-.327h-4.4V1.66Zm.688,25.07H.973V.973H15.534V6.548a.487.487,0,0,0,.486.488H21.6Z"
        />
        <path
          className="b"
          d="M41.819,3.44,41.3,3.163V1.073a.487.487,0,0,0-.268-.435L40.7.468a1.955,1.955,0,0,0-1.748,0l-.338.171a.486.486,0,0,0-.268.435V3.162l-.613.329a.486.486,0,0,0-.256.429V26.448a.477.477,0,0,0,.025.148.113.113,0,0,0,0,.015l1.863,5.257a.487.487,0,0,0,.918,0l1.862-5.257,0-.015a.5.5,0,0,0,.025-.148V4.484a1.747,1.747,0,0,1,1.264,1.673V14.7a.486.486,0,1,0,.973,0V6.157A2.723,2.723,0,0,0,41.819,3.44m-3.374,22.2V19.029l.917-.492a.972.972,0,0,1,.92,0l.916.492v6.607l-.457-.245a1.939,1.939,0,0,0-1.839,0Zm2.3-7.957a1.943,1.943,0,0,0-1.839,0l-.458.245V4.21l.917-.491a.974.974,0,0,1,.92,0l.916.491V17.924ZM39.385,1.337a.975.975,0,0,1,.873,0l.071.035V2.7a1.934,1.934,0,0,0-1.015,0V1.373Zm.437,28.912-1.265-3.57.805-.431a.97.97,0,0,1,.92,0l.8.431Z"
          transform="translate(-12.408 -0.087)"
        />
        <path
          className="b"
          d="M20.315,17.791H5.721a.486.486,0,0,0-.486.486V29.346a.486.486,0,0,0,.486.486H20.315a.486.486,0,0,0,.487-.486V18.277a.486.486,0,0,0-.487-.486M6.208,21.6H9.242V24.7H6.208Zm4.007,0h9.614V24.7H10.215Zm9.614-.973H10.215V18.764h9.614Zm-10.586,0H6.208V18.764H9.242ZM6.208,25.752H9.242v3.107H6.208Zm13.621,3.108H10.215V25.752h9.614Z"
          transform="translate(-1.733 -5.891)"
        />
        <path
          className="b"
          d="M5.235,13.913a.487.487,0,0,0,.486.487H20.315a.487.487,0,1,0,0-.973H5.721a.486.486,0,0,0-.486.486"
          transform="translate(-1.733 -4.446)"
        />
        <path
          className="b"
          d="M12.1,38.7H5.721a.486.486,0,0,0,0,.973H12.1a.486.486,0,0,0,0-.973"
          transform="translate(-1.733 -12.816)"
        />
        <path
          className="b"
          d="M26.309,38.7H23.823a.486.486,0,0,0,0,.973h2.486a.486.486,0,1,0,0-.973"
          transform="translate(-7.728 -12.816)"
        />
        <path
          className="b"
          d="M5.721,10.037h8.756a.487.487,0,0,0,0-.974H5.721a.487.487,0,0,0,0,.974"
          transform="translate(-1.733 -3.001)"
        />
      </g>
    </ContractIconSvg>
  )
}

ContractIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number
}

export default ContractIcon
